import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, catchError, of } from 'rxjs';
import { ChargepointService } from 'brain-data/service/chargepoint/chargepoint.service';
import { loadChargepointSummary, loadChargepointSummaryError, loadChargepointSummarySuccess } from '../actions/chargepoint.action';

@Injectable()
export class ChargepointEffects {
  loadChargepointSummary$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadChargepointSummary),
      switchMap(({ fromTimeStamp, toTimeStamp }) =>
        this.chargepointService.getChargePointSummary(fromTimeStamp, toTimeStamp).pipe(
          map(summary => loadChargepointSummarySuccess({ summary })),
          catchError(error => of(loadChargepointSummaryError({ error }))),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private chargepointService: ChargepointService,
  ) {}
}
